/* WARRANTY */
export const GET_WARRANTY = "GET_WARRANTY"
export const GET_WARRANTY_SUCCESS = "GET_WARRANTY_SUCCESS"
export const GET_WARRANTY_FAIL = "GET_WARRANTY_FAIL"